import { LogLevel } from '@azure/msal-browser';

const prodConfig = {
    clientId: 'd0ed6353-0629-41f8-b4c9-3f96fea8558c'
}
const devConfig = {
    clientId: '728e33e4-2f9a-48ca-b1a4-42ccf1da4104'
}
// Determine environment based on URL
// If URL contains 'dev' or is 'localhost', use development config
// Otherwise, use production config
const hostname = window.location.hostname.toLowerCase();
const isDevelopment = hostname.includes('dev') || hostname.includes('localhost') || hostname === '127.0.0.1';
const environment = isDevelopment ? 'development' : 'production';
const currentConfig = isDevelopment ? devConfig : prodConfig;
console.log(`Auth Config - Hostname: ${hostname}, Environment: ${environment}, Using clientId: ${currentConfig.clientId}`);

export const msalConfig = {
    auth: {
        authority: 'https://login.microsoftonline.com/16532572-d567-4d67-8727-f12f7bb6aed3',
        clientId: currentConfig.clientId,
        redirectUri: '/',
        postLogoutRedirectUri: '/',
        tenant: '16532572-d567-4d67-8727-f12f7bb6aed3',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true  // required when third-party cookies are blocked (modern browsers)
    },
    system: {
        allowNativeBroker: false, // Disables WAM Broker
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: [`${currentConfig.clientId}/.default`]
};

export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}